type IdleDeadlineLike = {
  didTimeout: boolean;
  timeRemaining: () => number;
};

type IdleCallbackLike = (deadline: IdleDeadlineLike) => void;

type IdleWindow = Window &
  typeof globalThis & {
    requestIdleCallback?: (
      callback: IdleCallbackLike,
      options?: { timeout?: number }
    ) => number;
    cancelIdleCallback?: (handle: number) => void;
  };

export const scheduleDeferredTask = (
  task: () => void,
  options?: { timeout?: number }
) => {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  const idleWindow = window as IdleWindow;
  let isCancelled = false;
  let idleHandle: number | null = null;
  let timeoutHandle: number | null = null;

  const runTask = () => {
    if (isCancelled) {
      return;
    }

    task();
  };

  const animationFrameHandle = window.requestAnimationFrame(() => {
    if (idleWindow.requestIdleCallback) {
      idleHandle = idleWindow.requestIdleCallback(
        () => {
          runTask();
        },
        { timeout: options?.timeout ?? 1500 }
      );

      return;
    }

    timeoutHandle = window.setTimeout(runTask, 0);
  });

  return () => {
    isCancelled = true;
    window.cancelAnimationFrame(animationFrameHandle);

    if (idleHandle !== null) {
      idleWindow.cancelIdleCallback?.(idleHandle);
    }

    if (timeoutHandle !== null) {
      window.clearTimeout(timeoutHandle);
    }
  };
};
